
import AppContent from "@/components/app/AppContent"
export default {
  components: { AppContent },
}
